// src/constants/deploymentModes.js  (frontend copy)
// Keep in sync with backend/src/constants/deploymentModes.js

export const DEPLOYMENT_MODES = {
  STANDALONE_FULL:        'STANDALONE_FULL',
  STANDALONE_POS_BRIDGE:  'STANDALONE_POS_BRIDGE',
  MALL_MANAGED:           'MALL_MANAGED',
  MALL_PLUS_STALL:        'MALL_PLUS_STALL',
  TABLE_QR_ONLY:          'TABLE_QR_ONLY',
};

export const DEPLOYMENT_MODE_LABELS = {
  STANDALONE_FULL:        'Model 1a — Solo (full service)',
  STANDALONE_POS_BRIDGE:  'Model 1b — Solo (POS bridge)',
  MALL_MANAGED:           'Model 2 — Mall managed',
  MALL_PLUS_STALL:        'Model 3a — Mall + stall kiosk',
  TABLE_QR_ONLY:          'Model 3b — Table QR only',
};

export const DEPLOYMENT_MODE_DESCRIPTIONS = {
  STANDALONE_FULL:        'Full QuickServe: kiosk, menu, kitchen, payments, analytics. No mall.',
  STANDALONE_POS_BRIDGE:  'Kiosk front-end only. Orders forwarded to existing POS. No mall.',
  MALL_MANAGED:           'Vendor onboarded by mall. Appears in shared court kiosk. Mall controls billing.',
  MALL_PLUS_STALL:        'In mall shared kiosk AND has own stall kiosk. Dual entry point.',
  TABLE_QR_ONLY:          'Orders via QR at table only. No counter kiosk. Kitchen display only.',
};

// Which tabs are visible per deployment mode
export const TAB_VISIBILITY = {
  STANDALONE_FULL: {
    kiosk: true, menu: true, orders: true, kitchen: true,
    billing: true, promos: true, analytics: true,
    pos: false, settings: true,
  },
  STANDALONE_POS_BRIDGE: {
    kiosk: true, menu: true, orders: true, kitchen: false,
    billing: true, promos: false, analytics: true,
    pos: true, settings: true,
  },
  MALL_MANAGED: {
    kiosk: false, menu: true, orders: true, kitchen: true,
    billing: false, promos: false, analytics: true,
    pos: false, settings: false,
  },
  MALL_PLUS_STALL: {
    kiosk: true, menu: true, orders: true, kitchen: true,
    billing: true, promos: true, analytics: true,
    pos: true, settings: true,
  },
  TABLE_QR_ONLY: {
    kiosk: false, menu: true, orders: true, kitchen: true,
    billing: false, promos: false, analytics: true,
    pos: false, settings: true,
  },
};

// Helper: get visible tabs for a vendor
export function getVisibleTabs(deploymentMode) {
  return TAB_VISIBILITY[deploymentMode] || TAB_VISIBILITY.STANDALONE_FULL;
}

// Helper: is a specific tab visible?
export function isTabVisible(deploymentMode, tab) {
  const tabs = getVisibleTabs(deploymentMode);
  return tabs[tab] !== false;
}
